import { ChatType } from "src/app/chats-panel/~store/models/enums/ChatType";
import i18n from "../../localization/i18n";

export const getChatTypeName = (chatType?: ChatType) => {
  switch (chatType) {
    case ChatType.Comment: return i18n.t('chat.chatTypeComment');
    case ChatType.Group: return i18n.t('chat.chatTypeGroup');
    case ChatType.Mailing: return i18n.t('chat.chatTypeMailing')
    default: return i18n.t('chat.chatTypePrivate');
  }
}

export const getChatTypeClass = (chatType?: ChatType) =>
{
  switch (chatType) {
    case ChatType.Comment: return 'chat-type-comment';
    case ChatType.Group: return 'chat-type-group';
    case ChatType.Mailing: return 'chat-type-mailing';
    default:  return 'chat-type-private';
  }
}
